import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export async function exportComprovantePDF(element, filename, applyStyleFn) {
	const WIDTH = 800;

	const iframe = document.createElement('iframe');
	iframe.style.cssText = `
		position: absolute;
		top: 0;
		left: -99999px;
		width: ${WIDTH}px;
		height: 1px;
		border: none;
	`;
	document.body.appendChild(iframe);

	const idoc = iframe.contentDocument;
	idoc.open();
	idoc.write('<!DOCTYPE html><html><head></head><body></body></html>');
	idoc.close();

	await copyStylesheets(idoc);

	const clone = element.cloneNode(true);

	if (typeof applyStyleFn === 'function') {
		applyStyleFn(clone, idoc, element);
	}

	clone.style.width = `${WIDTH}px`;
	idoc.body.style.margin = '0';
	idoc.body.appendChild(clone);

	try {
		if (idoc.fonts) {
			await Promise.all([...idoc.fonts].map(f => f.load().catch(() => null)));
			await idoc.fonts.ready;
		}

		const canvas = await html2canvas(idoc.body.firstElementChild, {
			scale: 2,
			useCORS: true,
			backgroundColor: '#fff',
			foreignObjectRendering: false
		});

		savePDFFromCanvas(canvas, filename);
	} finally {
		iframe.remove();
	}
}

// copia stylesheets do documento atual pro iframe, esperando cada um carregar
function copyStylesheets(idoc) {
	const styleNodes = [...document.querySelectorAll('link[rel="stylesheet"], style')];

	const loadPromises = styleNodes.map(node => {
		const cloned = node.cloneNode(true);
		idoc.head.appendChild(cloned);

		if (cloned.tagName === 'STYLE') return Promise.resolve();

		return new Promise(resolve => {
			cloned.addEventListener('load', resolve, { once: true });
			cloned.addEventListener('error', resolve, { once: true });
			setTimeout(resolve, 2000); // fallback de segurança
		});
	});

	return Promise.all(loadPromises);
}

// converte um canvas em PDF paginado (A4) e dispara o download
function savePDFFromCanvas(canvas, filename) {
	const pdf = new jsPDF('p', 'mm', 'a4');

	const pageWidth = pdf.internal.pageSize.getWidth();
	const pageHeight = pdf.internal.pageSize.getHeight();

	const imgWidth = pageWidth;
	const imgHeight = (canvas.height * imgWidth) / canvas.width;

	let heightLeft = imgHeight;
	let position = 0;

	const imgData = canvas.toDataURL('image/jpeg', 0.98);

	pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
	heightLeft -= pageHeight;

	while (heightLeft > 0) {
		position -= pageHeight;
		pdf.addPage();
		pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;
	}

	pdf.save(filename);
}